import { combineReducers } from '@reduxjs/toolkit';
import {
    ConfigurationParameters,
    DemandeurApi,
    DossierApi,
    Configuration,
} from '../../openApi/ApiSign';
import { type DossierSignatureConfigurationParameters } from './types';
import { createDemandeurSignatureSlice } from './slices/demandeurSlice';
import { createDossierSignatureSlice } from './slices/signatureSlice';
import { DOSSIER_SIGNATURE_SLICE_NAME, DEMANDEUR_SIGNATURE_SLICE_NAME } from './constants';

export function createSignatureReducer(configuration: ConfigurationParameters) {
    const { dossierSignatureDataSourcesThunks, dossierSignatureSlice } =
        createDossierSignatureSlice(configuration);
    const { demandeurSignatureDataSourcesThunks, demandeurSignatureSlice } =
        createDemandeurSignatureSlice(configuration);
    return {
        dossierSignatureDataSourcesThunks,
        dossierSignatureSlice,
        demandeurSignatureDataSourcesThunks,
        demandeurSignatureSlice,
    };
}

export function buildSignRedux(configuration: DossierSignatureConfigurationParameters) {
    const signConfiguration = new Configuration(configuration);

    const dossierApi = new DossierApi(signConfiguration);
    const demandeurApi = new DemandeurApi(signConfiguration);

    const {
        dossierSignatureSlice,
        dossierSignatureDataSourcesThunks,
        demandeurSignatureSlice,
        demandeurSignatureDataSourcesThunks,
    } = createSignatureReducer(configuration);

    const combinedSignReducer = combineReducers({
        [DOSSIER_SIGNATURE_SLICE_NAME]: dossierSignatureSlice.reducer,
        [DEMANDEUR_SIGNATURE_SLICE_NAME]: demandeurSignatureSlice.reducer,
    });

    return {
        serviceConfiguration: signConfiguration,
        serviceConfigurationParameters: configuration,

        reducer: combinedSignReducer,

        apis: {
            dossierApi,
            demandeurApi,
        },
        slices: {
            dossierSignatureSlice,
            demandeurSignatureSlice,
        },
        thunks: {
            dossierSignatureDataSourcesThunks,
            demandeurSignatureDataSourcesThunks,
        },

        fetchItems: {
            getDossierSignature: dossierSignatureDataSourcesThunks.main.getData,
            getDemandeurSignature: demandeurSignatureDataSourcesThunks.main.getData,
        },

        getItems: {
            selectDossierSignature: dossierSignatureDataSourcesThunks.main.getSelected,
            selectDemandeurSignature: demandeurSignatureDataSourcesThunks.main.getSelected,
        },
        models: {},
    };
}
